import { useRef } from "react";
import { motion, useInView } from "framer-motion";

/**
 * Line-by-line masked reveal.
 * useInView is attached to the (untransformed) wrapper for reliable triggering,
 * then each inner line translates up out of its overflow-hidden clip.
 */
export const MaskedReveal = ({
  lines = [],
  className = "",
  lineClassName = "",
  delay = 0,
  stagger = 0.12,
  duration = 1.05,
  as: Tag = "div",
  animateOnLoad = false,
}) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "0px 0px -12% 0px" });
  const active = animateOnLoad || inView;

  return (
    <Tag ref={ref} className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={active ? { y: "0%" } : { y: "115%" }}
            transition={{
              duration,
              delay: delay + i * stagger,
              ease: [0.22, 1, 0.36, 1],
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
};

export default MaskedReveal;
